import { Link } from 'react-router-dom';
import { animeSeries } from '@/mocks/anime';

export default function EpisodeSection() {
  const featured = animeSeries[0];
  const others = animeSeries.slice(1, 5);

  return (
    <section id="episode" className="mx-auto max-w-7xl scroll-mt-16 px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-primary-600">
            <i className="ri-flashlight-fill" /> 最新更新
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">热门分集剧情</h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-700 md:text-base">
            按话整理的每话简介持续更新，追更党可以直接对照最新一话的剧情走向。
          </p>
        </div>
        <Link
          to={`/anime/${featured.slug}`}
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
        >
          全部作品 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      {/* featured latest episode */}
      <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-5">
        <div className="lg:col-span-3">
          <article className="flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 sm:flex-row">
            <Link to={`/anime/${featured.slug}`} className="relative block aspect-[4/3] w-full shrink-0 overflow-hidden bg-background-200 sm:aspect-auto sm:w-64">
              <img
                src={featured.cover}
                alt={`${featured.title}分集剧情封面`}
                title={`${featured.title} 最新分集剧情`}
                className="h-full w-full object-cover object-top"
              />
            </Link>
            <div className="flex flex-1 flex-col p-5 md:p-6">
              <div className="flex flex-wrap items-center gap-2">
                <span className="rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-700">本期主打</span>
                <span className="text-xs text-foreground-600">更新至第 {featured.episodes.length} 话</span>
              </div>
              <h3 className="mt-3 font-heading text-xl font-bold text-foreground-950">
                <Link to={`/anime/${featured.slug}`} className="hover:text-primary-600">
                  {featured.title}
                </Link>
              </h3>
              <p className="mt-1 text-sm text-foreground-700">{featured.tagline}</p>
              <div className="mt-4 space-y-3 border-t border-background-200 pt-4">
                {featured.episodes.slice(-2).map((ep) => (
                  <div key={ep.num} className="flex items-start gap-3">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-100 text-xs font-bold text-accent-800">
                      {ep.num}
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">
                        {ep.num}话 · {ep.title}
                      </p>
                      <p className="mt-0.5 text-xs leading-5 text-foreground-700 line-clamp-2">{ep.summary}</p>
                    </div>
                  </div>
                ))}
              </div>
              <Link
                to={`/anime/${featured.slug}`}
                className="mt-auto inline-flex items-center gap-1.5 pt-4 text-sm font-medium text-primary-600 hover:text-primary-700"
              >
                查看全部 {featured.episodesCount} 话分集简介 <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </article>
        </div>

        {/* recent episode list */}
        <div className="lg:col-span-2">
          <div className="flex h-full flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
            <div className="flex items-center gap-2 px-4 py-3">
              <i className="ri-time-line text-primary-500" />
              <span className="text-sm font-semibold text-foreground-900">最近更新的每话简介</span>
            </div>
            {others.map((anime) => {
              const last = anime.episodes[anime.episodes.length - 1];
              return (
                <Link
                  key={anime.slug}
                  to={`/anime/${anime.slug}`}
                  className="group flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-100"
                >
                  <img
                    src={anime.cover}
                    alt={`${anime.title}封面`}
                    className="h-12 w-9 shrink-0 rounded-sm object-cover object-top"
                  />
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-600">
                      {anime.title}
                    </p>
                    <p className="truncate text-xs text-foreground-600">
                      第 {last.num} 话 · {last.title}
                    </p>
                  </div>
                  <i className="ri-arrow-right-s-line text-lg text-foreground-400 transition-transform group-hover:translate-x-0.5 group-hover:text-primary-500" />
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}